import loadLink from './link';
import loadScript from './script';

export {
  loadLink,
  loadScript,
};
